import React from 'react';
import { GRID_FILTER_KEYS } from '../../../Base/Components/GridFilter/gridFilterKeys';
import GridFilterItem from '../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../Base/Enums/GridFilterItemType.enum';
import GridFilter from '../../../Base/Components/GridFilter/GridFilter';
import useFilters from '../../../Base/Hooks/useFilters';
import moment, { Moment } from 'moment';
import { useAppContext } from '../../../../Services/AppContext';

interface ECardNewFilesListFilterValues {
	dateFrom?: Moment | string;
	dateTo?: Moment | string;
	patientId?: string;
	doctorId?: string;
	seen?: boolean;
}

interface Props {
	onFilter: (values: ECardNewFilesListFilterValues) => void;
}

const ECardNewFilesListFilter: React.FC<Props> = ({ onFilter }) => {
	const { isMou } = useAppContext();
	const { checkEmptyString, handleQuestionnaireSeenFilter, handleDateValue } =
		useFilters();

	const onFilterData = (values: any) => {
		const filter: ECardNewFilesListFilterValues = {
			dateFrom: handleDateValue(values?.dateFrom),
			dateTo: handleDateValue(values?.dateTo),
			patientId: values?.patient
				? checkEmptyString(values?.patient?.value)
				: undefined,
			doctorId: values?.doctor
				? checkEmptyString(values?.doctor?.value)
				: undefined,
			seen: handleQuestionnaireSeenFilter(values?.questionnaireSeen?.value),
		};

		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={(values: any) => onFilterData(values)}
			storageKey={GRID_FILTER_KEYS.FILLED_QUESTIONNAIRES_FILTER}>
			<GridFilterItem
				type={GridFilterItemType.DATE_FROM}
				width={170}
				customLabel='base.shared.from'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.DATE_TO}
				width={170}
				customLabel='base.shared.to'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ID}
				width={320}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.DOCTOR_ID}
				width={370}
				customPlaceholder='base.startTypingSurname'
				customLabel='base.shared.attendingDoctor'
				visible={isMou}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.QUESTIONNAIRE_SEEN}
				width={280}
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default ECardNewFilesListFilter;
